const filterLists = document.querySelectorAll('.js-filters__list');

filterLists.forEach(bsMenu => {
    bsMenu.addEventListener('click', function (e) {
        e.stopPropagation();
        bsMenu.classList.toggle('on');
    });

    // Close when clicking outside
    document.body.addEventListener('click', function () {
        bsMenu.classList.remove('on');
    });

    // Close on resize
    window.addEventListener('resize', function () {
        bsMenu.classList.remove('on');
    });
});
